<template>
  <div class="box">
    <div class="option">
      <el-button size="small" icon="el-icon-plus" @click="go" plain
        >新建人群</el-button
      >
      <div class="search">
        <el-input size="small" placeholder="请输入标签名称"></el-input>
        <el-button size="small">搜索</el-button>
      </div>
    </div>
    <div class="cards">
      <div class="ul">
        <div class="li" v-for="(item, index) in tableList" :key="index">
          <div class="title flex">
            <div>未消费潜在客户</div>
            <el-button size="small">拉新</el-button>
          </div>
          <div class="title-line">
            首次浏览店铺，且之后7-15天无支付行为的用户
          </div>
          <div class="numItem flex">
            <div>覆盖人数<span class="num">0</span></div>
            <div>营销记录<span class="num">0</span></div>
          </div>
          <div class="timeItem flex">
            <div class="time">
              <div>创建时间</div>
              <div>2020-04-02 10:49</div>
            </div>
            <div class="time">
              <div>更新时间</div>
              <div>2020-04-02 10:49</div>
            </div>
          </div>
          <!-- 操作 -->
          <div class="control flex">
            <div>手动更新</div>
            <div>编辑</div>
            <div>开启人群</div>
            <div>删除</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { listTag, delTag, listCommonTag, updateTag } from "@/api/market";
import { mapGetters } from "vuex";
export default {
  inject: ["reload"],
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data() {
    return {
      is_status: 1,
      page: 0,
      total: 0,
      tableList: [],
      CommonList: []
    };
  },
  mounted() {
    // if (this.$route.query.jude) {
    //   this.is_status = this.$route.query.jude;
    // }
    // this.getList();
  },
  methods: {
    go() {
      this.$router.push({
        path: `/apply/newVip/13/center/userManage/adSign`
      });
    },
    getList() {
      let data = {
        token: this.token,
        app_id: this.app_id
      };
      listTag(data).then(res => {
        if (res.code == 200) {
          this.tableList = res.data;
        } else {
          this.$message.waring(res.msg);
        }
        console.log("标签列表", res);
      });
    },
    del(judes, id) {
      console.log("删除", id);
      let data = {
        token: this.token,
        app_id: this.app_id,
        id: id
      };
      delTag(data).then(res => {
        if (res.code == 200) {
          this.$message.success(res.msg);
          this.reload();
          this.is_status = judes;
        } else {
          this.$message.waring(res.msg);
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.box {
  width: 100%;
  background: #f2f2f6;
  border-radius: 6px;
  padding: 10px;
}
.option {
  width: 100%;
  padding: 10px 20px;
  background-color: #fff !important;
  color: #595961;
  height: 50px;
  margin-bottom: 10px;
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
  .search {
    width: 345px;
    display: flex;
  }
}
.cards {
  padding-top: 15px;
  padding-bottom: 15px;
  border-radius: 6px;
  margin-bottom: 10px;
  .ul {
    width: 100%;
    height: auto;
    display: flex;
    flex-wrap: wrap;
    .li {
      width: 342px;
      height: 252px;
      padding: 15px;
      margin-right: 20px;
      margin-bottom: 20px;
      border-radius: 5px;
      border-top-width: 5px;
      border-top-style: solid;
      background-color: white;
      .title {
        font-size: 18px;
        align-items: center;
        font-weight: 600;
      }
      .title-line {
        margin: 10px 0 20px;
        color: #9797a1;
      }
      .numItem {
        margin-bottom: 14px;
        > div {
          width: 50%;
        }
        .num {
          padding: 0 5px;
          font-size: 18px;
          font-weight: 600;
        }
      }
      .timeItem {
        height: 60px;
        justify-content: space-between;
        .time {
          width: 150px;
          background: #f2f2f6;
          border-radius: 4px;
          padding: 10px;
          font-size: 12px;
          color: #9797a1;
          line-height: 20px;
        }
      }
      .control {
        margin-top: 20px;
      }
    }
  }
}
.flex {
  display: flex;
  justify-content: space-between;
}
</style>
